import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTrackingByUuid(uuid) {
  return request({
    url: URL.sys.trackingByUuid,
    method: 'get',
    params: { uuid }
  })
}

export function getTrackingList(params) {
  return request({
    url: URL.sys.tracking,
    method: 'get',
    params
  })
}

export function saveTracking(data, uuid) {
  return request({
    url: URL.sys.tracking,
    method: uuid ? 'put' : 'post',
    data
  })
}

export function delTracking(uuid) {
  return request({
    url: URL.sys.tracking,
    method: 'delete',
    params: { uuid }
  })
}
export function getTrackingDetailByUuid(uuid) {
  return request({
    url: URL.sys.trackingDetailByUuid,
    method: 'get',
    params: { uuid }
  })
}
// 获取节点状态明细（包含预警明细，sop推送信息）
export function queryTrackingDetailByKey(uuid, currentBranchId) {
  return request({
    url: URL.sys.queryTrackingDetailByKey,
    method: 'get',
    params: { uuid, currentBranchId }
  })
}

export function getTrackingDetailList(params) {
  return request({
    url: URL.sys.trackingDetail,
    method: 'get',
    params
  })
}

export function saveTrackingDetail(data, uuid) {
  return request({
    url: URL.sys.trackingDetail,
    method: uuid ? 'put' : 'post',
    data
  })
}
export function saveTrackingDetailInfo(data) {
  return request({
    url: URL.sys.saveTrackingDetail,
    method: 'post',
    data
  })
}

export function saveTrackingDetailBatch(data) {
  return request({
    url: URL.sys.saveTrackingDetailBatch,
    method: 'post',
    data
  })
}

export function sendTestEmail(data) {
  return request({
    url: URL.sys.trackingSopConfigSendTestEmail,
    method: 'post',
    data
  })
}

export function sendTestNote(data) {
  return request({
    url: URL.sys.trackingSopConfigSendTestNote,
    method: 'post',
    data
  })
}

export function delTrackingDetail(uuid) {
  return request({
    url: URL.sys.trackingDetail,
    method: 'delete',
    params: { uuid }
  })
}

export function getTrackingTree() {
  return request({
    url: URL.sys.trackingTree,
    method: 'get'
  })
}

export function getSopStateTracks(lob) {
  return request({
    url: URL.sys.sopStateTrack,
    method: 'get',
    params: { lob }
  })
}

export function getTrackingSopTree() {
  return request({
    url: URL.sys.trackingSopTree,
    method: 'get'
  })
}
export function loadSopBySopTemplateKey(params) {
  return request({
    url: URL.sys.loadSopBySopTemplateKey,
    method: 'get',
    params
  })
}

export function sopTreeByLob(params) {
  return request({
    url: URL.sys.sopTreeByLob,
    method: 'get',
    params
  })
}

export function getDocTypeByLob(lob) {
  return request({
    url: URL.sys.docTypeByLob,
    method: 'get',
    params: { lob }
  })
}

export function getTrackingDetailExternal() {
  return request({
    url: URL.sys.trackingDetailExternal,
    method: 'get'
  })
}

export function getTemplateTheme(code) {
  return request({
    url: URL.sys.trackingSopTempTheme,
    method: 'get',
    params: { code }
  })
}

export function getTrackingSopList(params) {
  return request({
    url: URL.sys.trackingSopConfig,
    method: 'get',
    params
  })
}

export function getTrackingSopDetail(uuid) {
  return request({
    url: URL.sys.trackingSopConfigDetail,
    method: 'get',
    params: { uuid }
  })
}

export function saveTrackingSop(data, uuid) {
  return request({
    url: URL.sys.trackingSopConfig,
    method: uuid ? 'put' : 'post',
    data
  })
}
export function delTrackingSop(uuid) {
  return request({
    url: URL.sys.trackingSopConfig,
    method: 'delete',
    params: { uuid }
  })
}

export function updateTrackingByEvent(data) {
  return request({
    url: URL.sys.updateTrackingByEvent,
    method: 'put',
    data
  })
}

export function batchUpdateTrackingByEvent(jobUuids, filedCode) {
  return request({
    url: URL.sys.batchUpdateTrackingByEvent,
    method: 'post',
    data: jobUuids,
    params: { filedCode }
  })
}

export function queryChargeSchemeDetailTrackingFunc(uuid, currentBranchId) {
  return request({
    url: URL.mdm.queryChargeSchemeDetailTrackingUrl,
    method: 'get',
    params: { uuid, currentBranchId }
  })
}

export function saveChargeSchemeDetailTrackingFunc(data) {
  return request({
    url: URL.mdm.saveChargeSchemeDetailTrackingUrl,
    method: 'post',
    data
  })
}

// 获取sop模板树
export function getTenantSopTemplate() {
  return request({
    url: URL.sys.getTenantSopTemplate,
    method: 'get'
  })
}
// 获取sop模板树
export function queryNodeTreeByTemplateKey(params) {
  return request({
    url: URL.sys.queryNodeTreeByTemplateKey,
    method: 'get',
    params
  })
}
// 获取平台指定业务类型的节点列表
export function getPlatformSopInfo(params) {
  return request({
    url: URL.sys.getPlatformSopInfo,
    method: 'get',
    params
  })
}

// 获取租户sop模板详情
export function getTenantSopTemplateDetail(params) {
  return request({
    url: URL.sys.getTenantSopTemplateDetail,
    method: 'get',
    params
  })
}

// 删除节点明细（包含节点状态、预警明细，sop推送信息）
export function deleteTrackingByKey(params) {
  return request({
    url: URL.sys.deleteTrackingByKey,
    method: 'get',
    params
  })
}

// 删除节点状态明细（包含预警明细，sop推送信息）
export function deleteTrackingDetailByKey(params) {
  return request({
    url: URL.sys.deleteTrackingDetailByKey,
    method: 'get',
    params
  })
}

// 保存租户预警模板信息
export function saveTenantSopTemplate(data) {
  return request({
    url: URL.sys.saveTenantSopTemplate,
    method: 'post',
    data
  })
}

// 删除租户预警模板信息
export function delTenantSopTemplate(params) {
  return request({
    url: URL.sys.delTenantSopTemplate,
    method: 'get',
    params
  })
}
// 复制租户sop模板信息
export function copySopTemplate(params) {
  return request({
    url: URL.sys.copySopTemplate,
    method: 'get',
    params
  })
}

// 获取港区服务开通状态
export function getOpenSubscribe() {
  return request({
    url: URL.sys.getOpenSubscribe,
    method: 'get'
  })
}

// 获取租户模板列表
export function queryTenantAllSopTemplate() {
  return request({
    url: URL.sys.queryTenantAllSopTemplate,
    method: 'get'
  })
}

// 获取已完成节点的明细列表
export function queryCompleteTrackingDetails(params) {
  return request({
    url: URL.sys.queryCompleteTrackingDetails,
    method: 'get',
    params
  })
}

// 业务状态清空图片
export function clearTrackingDocumentId(data) {
  return request({
    url: URL.sys.clearTrackingDocumentId,
    method: 'post',
    data
  })
}

// 禁用租户sop模板信息
export function updateTenantSopStatus(params) {
  return request({
    url: URL.sys.updateTenantSopStatus,
    method: 'post',
    params
  })
}

// 获取SOP模板配置
export function getSopTemplateConfig(params) {
  return request({
    url: URL.sys.getSopTemplateConfig,
    method: 'post',
    params
  })
}

// 保存SOP模板配置
export function saveSopTemplateConfig(data) {
  return request({
    url: URL.sys.saveSopTemplateConfig,
    method: 'post',
    data
  })
}
